import { Button, Col, Container, Row } from "react-bootstrap"
import { BranchData, useBranch, UserBranch } from "../../api/branch/store"
import Label from "../../components/Label"
import { useAuth } from "../../api/auth/store"
import useUXStore from "../../api/ux/store"
import DropdownControl from "../../components/DropdownControl"
import { useEffect, useState } from "react"
import CookieButton from "../../components/Cookie"
import { ReactComponent as AddIcon} from "../../svgs/add.svg"
import SwitchControl from "../../components/SwitchControl"

type BranchAssignProps = {
    assigned: UserBranch[]
    userid: string
    edit: boolean
}

const servicingColor = "rgb(0, 175, 6)"

const BranchSelector = ({com="",userid="", onSelected=(branch:BranchData,selected:boolean)=>{}}) => {
    const { branches, userBranches} = useBranch(state => state)
    const [selected,setSelected] = useState(0)
    const [activeBr,setActiveBr] = useState<BranchData[]>([])
    const [servicing,setServicing] = useState(true)
    useEffect( ()=> {
        const isBrSelected = (tofind:string) => 
            userBranches[userid] &&
            userBranches[userid]!.findIndex(ubr => ubr.id === tofind) >= 0
        if (!branches[com]) return

        const filtered = branches[com]!.filter(item => !isBrSelected(item.id))
        setActiveBr(filtered)
    }, [userid,com])
    const _onSelected = (key:string|null,index:number) => {
        setSelected(index)
    }
    const _onAdd = () => {
        onSelected(activeBr[selected],servicing)
    }
    return <Container>
        <Row>
            <Col>
                <DropdownControl text="Branches" 
                    items={activeBr.map( item => item.name)}
                    selected={selected}
                    onSelected={_onSelected}/>
            </Col>
        </Row>
        <Row>
            <Col>
                <SwitchControl text="Servicing Branch" value={servicing} onChanged={setServicing}/>
            </Col>
        </Row>
        <Row>
            <Col md={{span:10,offset:10}} >
                <Button style={{marginTop:10}} onClick={_onAdd}>Add</Button>
            </Col>
        </Row>
    </Container>
}

const BranchAssign:React.FC<BranchAssignProps> = ({assigned, userid,edit}) => {
    const { branches, addUserBranch, removeUserBranch} = useBranch(state => state)
    const { currentCompany } = useAuth( state => state)
    const { refreshDialog, hideDialog } = useUXStore(state => state)

    if (!branches[currentCompany] || branches[currentCompany]!.length === 0) 
        return <></>

    const onAdded = (branch:BranchData,servicing:boolean) => {
        hideDialog("branchList")
        addUserBranch(userid, currentCompany, branch.id, servicing)
        // TODO: add toast
    }
    const onAdd = () => {
        refreshDialog({
            id: "branchList",
            title: "Assign Branch",
            visible: true,
            content: <BranchSelector com={currentCompany} userid={userid} onSelected={onAdded}/>
        }, true)
    }
    const onRemoved = (branch:UserBranch) => {
        removeUserBranch(currentCompany, userid, branch.id)
        // TODO: add toast
    }
    const showAddButton = edit && (!assigned || assigned.length < branches[currentCompany]!.length)
    const AddButton = () => (
        <Col style={{padding:"0"}}>
            <Button style={{padding:"2px 0"}} size="sm" variant="" onClick={onAdd}><AddIcon stroke="rgb(103, 158, 255)"/></Button>
        </Col>
    )
    return <div style={{marginBottom:20}}>
            <Row>
                <Col xs="auto"><Label size="medium" color="black" textAlign="left" padding="0">Branches Assigned</Label></Col>
                {showAddButton && (!assigned || assigned.length === 0) && <AddButton />}
                {!edit && (!assigned || assigned.length === 0) && <Col xs="auto" style={{padding:0}}>
                    <Label color="gray" size="medium" padding="0 0 0 10px">None</Label>
                </Col>}
            </Row>
            <Row xs="auto">
                {assigned && assigned.map(branch => <Col md="auto" key={"br"+branch.id} style={{padding:"2px"}}>
                    <CookieButton 
                        bgColor={branch.servicing? servicingColor:""}
                        edit={edit} 
                        onRemoved={() => onRemoved(branch)}>
                        {branch.branch}
                    </CookieButton>
                </Col>)}
                {showAddButton && assigned && assigned.length > 0 && <AddButton/>}
            </Row>
    </div>
}

export default BranchAssign